export default __webpack_public_path__ + "static/media/undraw_date_picker_gorr.295a4ef2.svg";